import Exif from 'exif-js'
const dcraw = require('dcraw')
export function env () {
  const host = document.location.host
  let env = 'test'
  if (/tool.vb.com.cn/.test(host)) {
    env = 'online'
  } else if (/tool.vizen.cn/.test(host)) {
    env = 'online'
  } else if (/localhost|127.0.0.1|192.168.1.|172.20.10./g.test(host)) {
    env = 'local'
  } else if (/pre.visualbusiness.cn/.test(host)) {
    env = 'test'
  } else if (/tool.dev.vizen.cn/.test(host)) {
    env = 'dev'
  }
  return env
}

var bucket = {
  local: 'panopublictest',
  dev: 'panopublictest',
  test: 'panopublictest',
  online: 'panopublic',
  pre: 'panopublic'
}
var threeDBucket = {
  local: 'test-public-vbr3d',
  dev: 'test-public-vbr3d',
  test: 'test-public-vbr3d',
  online: 'prod-public-vbr3d',
  pre: 'prod-public-vbr3d'
}
var threeDSence = {
  local: 'http://prod-model-vbr3d.oss-cn-beijing.aliyuncs.com/scenes',
  dev: 'http://prod-model-vbr3d.oss-cn-beijing.aliyuncs.com/scenes',
  test: 'http://prod-model-vbr3d.oss-cn-beijing.aliyuncs.com/scenes',
  online: 'https://prod-model-vbr3d.oss-cn-beijing.aliyuncs.com/scenes',
  pre: 'http://prod-model-vbr3d.oss-cn-beijing.aliyuncs.com/scenes'
}
var picBuc = {
  local: 'luna',
  dev: 'luna',
  test: 'luna',
  online: 'luna',
  pre: 'luna'
}
// 万象优图的路径
var resourPicShow = {
  local: '//panopublictest-1251448083.picsh.myqcloud.com',
  dev: '//panopublictest-1251448083.picsh.myqcloud.com',
  test: '//panopublictest-1251448083.picsh.myqcloud.com',
  // pre: '//panopublic-1251448083.picsh.myqcloud.com',
  // online: '//panopublic-1251448083.picsh.myqcloud.com'
  pre: '//cimg4.vizen.cn',
  online: '//cimg4.vizen.cn'
}
// bucket 的直接路径
var resourPicFact = {
  local: '//panopublictest-1251448083.file.myqcloud.com',
  dev: '//panopublictest-1251448083.file.myqcloud.com',
  test: '//panopublictest-1251448083.file.myqcloud.com',
  pre: '//panopublic-1251448083.file.myqcloud.com',
  online: '//panopublic-1251448083.file.myqcloud.com'
}
var skyPicBucket = {
  local: '//panomedias-10002033.image.myqcloud.com',
  dev: '//panomedias-10002033.image.myqcloud.com',
  test: '//panomedias-10002033.image.myqcloud.com',
  pre: '//panomedias-10002033.image.myqcloud.com',
  online: '//panomedias-10002033.image.myqcloud.com'
}

export const myBucket = bucket[env()]
export const myThreeDBucket = threeDBucket[env()]
export const threeDSencePath = threeDSence[env()]
export const picBucket = picBuc[env()]
export const resourPicShowUrl = resourPicShow[env()]
export const resourPicFactUrl = resourPicFact[env()]

var shot = {
  local: '//shot.dev.vizen.cn',
  dev: '//shot.dev.vizen.cn',
  test: '//shot.test.vizen.cn',
  pre: '//shot.dev.vizen.cn',
  online: '//shot.vizen.cn'
}
var show = {
  local: '//show.dev.vizen.cn',
  dev: '//show.dev.vizen.cn',
  test: '//show.test.vizen.cn',
  pre: '//show.dev.vizen.cn',
  online: '//show.vizen.cn'
}
export const shotUrl = shot[env()]
export const showUrl = show[env()]

// websocket地址
var websocketApiUrl = {
  local: 'ws://api.pano.test.vizen.cn/api/websocket',
  dev: 'ws://api.pano.test.vizen.cn/api/websocket',
  test: 'ws://api.pano.test.vizen.cn/api/websocket',
  pre: 'ws://api.pano.vizen.cn/api/websocket',
  online: 'wss://api.pano.vizen.cn/api/websocket'
}
export const websocketUrl = websocketApiUrl[env()]

// websocket地址
var modelWebsocketApiUrl = {
  local: 'ws://api.r3d.test.vizen.cn/api/websocket',
  dev: 'ws://api.r3d.test.vizen.cn/api/websocket',
  test: 'ws://api.r3d.test.vizen.cn/api/websocket',
  pre: 'ws://api.r3d.vizen.cn/api/websocket',
  online: 'wss://api.r3d.vizen.cn/api/websocket'
}
export const modelWebsocketUrl = modelWebsocketApiUrl[env()]

// 补地水印图片
export const patchImg = '//panoappstage-1251448083.costj.myqcloud.com/budishuiyin.png'
export const cosHost = 'https://cimg.vizen.cn'

export const shotType = {
  '1': '平视（步采)',
  '2': '高杆',
  '3': '航拍'
}

export function allowedEditStatus (status) {
  const allowedStatusArry = [0, 10, 20, 31]
  if (allowedStatusArry.indexOf(status) > -1) {
    return true
  } else {
    return false
  }
}

export function formatDate (date, format) {
  if (!date) {
    return date
  }
  if (!format) {
    format = 'yyyy-MM-dd hh:mm'
  }
  let dateTime
  if (/^\d{10}$/.test(date)) {
    dateTime = new Date(date * 1000)
  } else {
    dateTime = new Date(date)
  }

  var o = {
    'M+': dateTime.getMonth() + 1, // month
    'd+': dateTime.getDate(), // day
    'h+': dateTime.getHours(), // hour
    'm+': dateTime.getMinutes(), // minute
    's+': dateTime.getSeconds(), // second
    'q+': Math.floor((dateTime.getMonth() + 3) / 3), // quarter
    'S': dateTime.getMilliseconds() // millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (dateTime.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

export const Cookie = {
  install (Vue) {
    Vue.prototype.$cookie = {
      exp: 5 * 24 * 60 * 60, // 5Days
      get: function (name) {
        var cookieStr = '; ' + document.cookie + '; '
        var index = cookieStr.indexOf('; ' + name + '=')
        if (index !== -1) {
          var s = cookieStr.substring(index + name.length + 3, cookieStr.length)
          return decodeURIComponent(s.substring(0, s.indexOf('; ')))
        } else {
          return null
        }
      },
      set: function (name, value, exp, domain) {
        var cookieStr = null
        var expires = null
        if (exp) {
          /* *
           * expires表示过期时间点
           * max-age表示以秒为单位的时间段
          var expTime = new Date(new Date().getTime() + exp)
          expires = '; expires=' + exp.toUTCString()
           */
          expires = '; max-age=' + exp
        } else {
          expires = ''
        }
        cookieStr = name + '=' + encodeURIComponent(value) + expires + '; path=/'
        if (domain) {
          cookieStr += ';domain=' + domain
        }
        document.cookie = cookieStr
      },
      cookieToJson: function () {
        var cookieArr = document.cookie.split(';')
        let obj = {}
        cookieArr.forEach((i) => {
          let arr = i.split('=')
          obj[arr[0]] = arr[1]
        })
        return obj
      },
      del: function (name) {
        var exp = new Date(new Date().getTime() - 1)
        var s = encodeURIComponent(this.get(name))
        if (s != null) {
          document.cookie = name + '=' + s + ';expires=' + exp.toGMTString() + ';path=/'
        }
      },
      saveCookies: function (data, remindMe) {
        if (remindMe === 1) {
          for (let i in data) {
            this.set(i, data[i], this.exp)
          }
        } else {
          for (let i in data) {
            this.set(i, data[i])
          }
        }
        // const {userInfo, company, name, showName, lunaName, isAdmin, auditStatus, phone, type, identification, email} = data
        // if (remindMe === 1) {
        //   this.set('userinfo', userInfo || 0, this.exp)
        //   this.set('company', company || 0, this.exp)
        //   this.set('username', name, this.exp)
        //   this.set('showName', showName || lunaName, this.exp)
        //   this.set('admin', isAdmin, this.exp)
        //   this.set('auditStatus', auditStatus, this.exp)
        //   this.set('phone', phone, this.exp)
        //   this.set('type', type, this.exp)
        //   this.set('identification', identification, this.exp)
        //   this.set('email', email || '', this.exp)
        // } else {
        //   this.set('userinfo', userInfo || 0)
        //   this.set('company', company || 0)
        //   this.set('username', name)
        //   this.set('showName', showName || lunaName)
        //   this.set('admin', isAdmin)
        //   this.set('auditStatus', auditStatus)
        //   this.set('phone', phone)
        //   this.set('type', type)
        //   this.set('identification', identification)
        //   this.set('email', email || '')
        // }
      },
      delCookies: function () {
        let cookie = this.cookieToJson()
        for (let i in cookie) {
          this.del(i)
        }
      }
    }
  }
}

export function getSkyImageUrl (params) {
  return `${skyPicBucket[env()]}/skyPatchimg/${params.id}/skypatch.jpg`
}

export function panoramaSetpanoId (panoObj, panoInfoOut, callback, payType) {
  let panoInfo = JSON.parse(JSON.stringify(panoInfoOut))
  if (env() !== 'online' && env() !== 'pre') {
    panoInfo.panoId = '[TT]' + panoInfo.panoId
  }
  let filterName = ''
  !panoInfo.filterTemplateId || panoInfo.filterTemplateId === 'orginal' ? filterName = '' : filterName = panoInfo.filterTemplateId
  panoObj.setPanoIdAndFilterName(panoInfo.panoId, filterName, function () {
    if (payType === 0) { // 没付费有水印
      panoObj.setWatermarkEnable(true)
    }
    panoInfo.heading && panoObj.setHeading(panoInfo.heading)
    panoInfo.pitch && panoObj.setPitch(panoInfo.pitch)
    panoInfo.panoType === 2 && this.panoView.addPatch(patchImg, 0, 90, 60, 60)
    setTimeout(() => {
      // this.panoViewInternal.setZoom(panoInfo.viewLevel || 0)
    }, 100)
    if (callback) {
      callback()
    }
  })
}
export function modelSetModelId (modelObj, modelInfoOut, callback) {
  let modelInfo = JSON.parse(JSON.stringify(modelInfoOut))
  let vbrId = ''
  if (env() !== 'online' && env() !== 'pre') {
    vbrId = '[TT]' + modelInfo.vbrId
  } else {
    vbrId = modelInfo.vbrId
  }
  modelObj.setLevelCount(2)
  modelObj.setModelIdAndJobId(vbrId, modelInfo.path, function () {
    modelObj.onModelLoadedCallback = function () {
      console.log('Model has loaded.')
      var image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = '//panoappstage-1251448083.file.myqcloud.com/mobel/modelDecals.png'
      image.onload = function () {
        setTimeout(function () {
          modelObj.requestDraw()
          modelObj.decals(image)
        }, 1000)
      }
    }
    if (modelInfo.pose) {
      let pose = JSON.parse(modelInfo.pose)
      // 兼容历史数据
      if (pose.pivotVersion) {
        modelObj.reloadPivotInfo(pose)
      } else {
        let data = {
          pivotVersion: 0,
          pose: modelInfo.pose
        }
        modelObj.reloadPivotInfo(data)
      }
    }
    callback && callback()
  })
}
// 从引擎上截图截图
export function captureFromVizen (dom, name, width, height, callback) {
  function dataURLtoBlob (name, dataurl) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime }, { name: new Date() + name })
  }
  let originalImgSrc = dom.toDataURL('image/jpg')
  let originalImg = document.createElement('img')
  originalImg.setAttribute('src', originalImgSrc)
  originalImg.setAttribute('id', 'originalImg')
  originalImg.setAttribute('width', width)
  originalImg.setAttribute('height', height)
  originalImg.onload = function () {
    let newCanvas = document.createElement('canvas')
    newCanvas.width = width
    newCanvas.height = height
    newCanvas.getContext('2d').drawImage(originalImg, 0, 0, width, height)
    let img = newCanvas.toDataURL('image/jpg')
    let obj = {
      dataURL: img,
      blob: dataURLtoBlob(name, img)
    }
    callback(obj)
  }
}

/*eslint-disable */
export function checkPicture (files, callback) {
  var picExif = {}
  var results = []
  // if (rules) {
  //   let rules = rules
  // } else {
  //   let rules = {
  //     width: 0,
  //     height: 0,
  //     focal: 15,
  //     model: ''
  //   }
  // }
  var rules = []
  if (files.length === 0) {
    callback(false)
  } else {
    var length = files.length
    for (let i = 0; i < files.length; i++) {
      Exif.getData(files[i], function () {
        var tags = Exif.getAllTags(this)
        if (i === 0) {
          rules.model = tags.Model
          rules.focal = parseInt(tags.FocalLength)
          if (tags.Orientation === 1 || tags.Orientation === 3) {
            rules.width = tags.PixelXDimension
            rules.height = tags.PixelYDimension
          }
          if (!picExif.width || !picExif.height) {
            getWidthHeight(files[i], (width, height) => {
              if (tags.Orientation === 6 || tags.Orientation === 8) {
                rules.width = height
                rules.height = width
              } else {
                rules.width = width
                rules.height = height
              }
            })
          }
        }
        picExif.model = decodeURI(encodeURI(tags.Model).replace(/%00/g, ''))
        picExif.focal = parseInt(tags.FocalLength)
        if (tags.Orientation === 1 || tags.Orientation === 3) {
          picExif.width = tags.PixelXDimension
          picExif.height = tags.PixelYDimension
        }
        if (!picExif.width || !picExif.height) {
          getWidthHeight(files[i], (width, height) => {
            if (tags.Orientation === 6 || tags.Orientation === 8) {
              picExif.width = height
              picExif.height = width
            } else {
              picExif.width = width
              picExif.height = height
            }
            results.push(picExif)
            if (results.length === length) {
              filesjudge(results)
            }
          })
        } else {
          results.push(picExif)
          if (results.length === length) {
            filesjudge(results)
          }
        }
      })
    }
  }
  function filesjudge (results) {
    console.log(results)
    /***
      json代表成功
      0 exif不统一
      -1 没exif
    ***/
    if (results.length === 1) {
      if (results[0].model === undefined || isNaN(results[0].focal)) {
        callback(-1)
      } else {
        callback(results[0])
      }
    } else if (results.length > 1 && results[0].width === rules.width && results[0].height === rules.height && results[0].focal === rules.focal) {
      for (let j = 0; j < results.length; j++) {
        if (results[j].model === results[0].model && results[j].width === results[0].width && results[j].height === results[0].height && results[j].focal === results[0].focal) {
          if (j === results.length - 1) {
            callback(results[0])
          }
        } else {
          if (results[0].model === undefined || isNaN(results[0].focal)) {
            callback(-1)
          } else {
            callback(0)
          }
        }
      }
    } else {
      callback(0)
    }
  }
  function getWidthHeight (fileData, callback) {
    // 读取图片数据
    var reader = new FileReader()
    reader.onload = function (e) {
      var data = e.target.result
      // 加载图片获取图片真实宽度和高度
      var image = new Image()
      image.onload = function () {
        var width = this.width
        var height = this.height
        callback(width, height)
      }
      image.src = data
    }
    reader.readAsDataURL(fileData)
  }
}
/**
 * 获取图片exif信息 参考上面的方法
 * @param {*} file
 */
export function getExifInfo (file) {
  var picExif = {}
  function getWidthHeight (fileData, callback) {
    // 读取图片数据
    var reader = new FileReader()
    reader.onload = function (e) {
      var data = e.target.result
      // 加载图片获取图片真实宽度和高度
      var image = new Image()
      image.onload = function () {
        var width = this.width
        var height = this.height
        callback(width, height)
      }
      image.src = data
    }
    reader.readAsDataURL(fileData)
  }
  const promise = new Promise((resolve, reject) => {
    if (!file) {
      reject(false)
    } else {
      Exif.getData(file, function () {
        var allMetaData = Exif.getAllTags(this)
        picExif.model = allMetaData.Model ? decodeURI(encodeURI(allMetaData.Model).replace(/%00/g, '')) : ''
        picExif.focal = allMetaData.FocalLength ? parseInt(Math.round(allMetaData.FocalLength.valueOf())) : ''
        picExif.iso = allMetaData.ISOSpeedRatings || ''
        picExif.ColorSpace = allMetaData.ColorSpace || ''
        picExif.ExposureTime = allMetaData.ExposureTime ? allMetaData.ExposureTime.valueOf() : ''
        picExif.FNumber = allMetaData.FNumber ? allMetaData.FNumber.valueOf() : ''
        if (allMetaData.Orientation === 1 || allMetaData.Orientation === 3) {
          picExif.width = allMetaData.PixelXDimension
          picExif.height = allMetaData.PixelYDimension
        }
        if (!picExif.width || !picExif.height) {
          getWidthHeight(file, (width, height) => {
            if (allMetaData.Orientation === 6 || allMetaData.Orientation === 8) {
              picExif.width = height
              picExif.height = width
            } else {
              picExif.width = width
              picExif.height = height
            }
            resolve(picExif)
          })
        } else {
          resolve(picExif)
        }
      })
    }
  })
  return promise
}

/**
 * 获取cr2图片信息
 * @param {*} file
 */
export function getCr2Info (file) {
  var picExif = {}
  const promise = new Promise((resolve, reject) => {
    if (!file) {
      reject(false)
    } else {
      var reader = new FileReader()
      reader.onload = (function (o) {
        return function (e) {
          // Get the image file as a buffer
          var buf = new Uint8Array(e.currentTarget.result)

          // Get the RAW metadata
          var metadata = dcraw(buf, { verbose: true, identify: true }).split('\n').filter(String)
          var allMetaData = {}
          metadata.forEach((item, index) => {
            let arr = item.split(':').map((ite) => {
              return ite.trim()
            })
            allMetaData[arr[0]] = arr.slice(1).join(':')
          })

          picExif.model = allMetaData.Camera ? decodeURI(encodeURI(allMetaData.Camera).replace(/%00/g, '')) : ''
          picExif.focal = allMetaData['Focal length'] ? parseInt(Math.round(parseFloat(allMetaData['Focal length']))) : ''
          picExif.iso = Number(allMetaData['ISO speed']) || ''
          picExif.ColorSpace = allMetaData.ColorSpace || ''//这个没找到对应的
          picExif.ExposureTime = allMetaData.ExposureTime ? allMetaData.ExposureTime.valueOf() : ''//这个没找到对应的
          picExif.FNumber = allMetaData.FNumber ? allMetaData.FNumber.valueOf() : ''//这个没找到对应的
          picExif.shootingTime = allMetaData.Timestamp || ''

          var imageSize = allMetaData['Image size']
          picExif.width = imageSize.split('x')[0] ? Number(imageSize.split('x')[0]) : 0
          picExif.height = imageSize.split('x')[1] ? Number(imageSize.split('x')[1]) : 0
          resolve(picExif)
        }
      })(file)
      reader.readAsArrayBuffer(file)
    }
  })
  return promise
}

window.jsSHA = require('../assets/js/jssha')
require('../assets/js/spark-md5.min')

export function getMd5 (file, callback) {
  var running = false
  if (running) {
    return
  }
  var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
  var chunkSize = 2097152                        // read in chunks of 2MB
  var chunks = Math.ceil(file.size / chunkSize)
  var currentChunk = 0
  /* eslint-disable no-undef */
  var spark = new SparkMD5.ArrayBuffer()
  /* eslint-enable no-undef */
  var fileReader = new FileReader()
  fileReader.onload = function (e) {
    spark.append(e.target.result)                // append array buffer
    currentChunk += 1
    if (currentChunk < chunks) {
      loadNext()
    } else {
      running = false
      callback(spark.end())
    }
  }
  fileReader.onerror = function () {
    running = false
    console.log('error')
  }
  function loadNext () {
    var start = currentChunk * chunkSize
    var end = start + chunkSize >= file.size ? file.size : start + chunkSize
    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
  }
  running = true
  loadNext()
}
var last
export function debounce (idle, action) {
  return function () {
    clearTimeout(last)
    last = setTimeout(function () {
      action()
    }, idle)
  }
}

export function createObjUrl (file) {
  try {
    var url = URL.createObjectURL(file)
    return url
  } catch (error) {
    console.error('生成本地url失败')
    return ''
  }
}
/**
 * @param {any} url
 */
export function revokeObjUrl (mediaObj) {
  try {
    if (mediaObj.localUrl) {
      URL.revokeObjectURL(mediaObj.localUrl)
      mediaObj.localUrl = ''
    }
  } catch (error) {
    console.error('消除本地url失败')
    return
  }
}

export function uuid (len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = [], i
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    var r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('')
}
// 判断a数组是否完全包含b数组
export function isContained (a, b) {
  if (!(a instanceof Array) || !(b instanceof Array)) {
    return false
  }
  if (a.length < b.length) {
    return false
  }
  var aStr = a.toString();
  for (var i = 0, len = b.length; i < len; i++) {
    if (aStr.indexOf(b[i]) == -1)
      return false;
  }
  return true;
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/filters/index.js